<template>
    <div>
        <div class="vx-row">
            <div class="w-full vx-col">
                <vs-tabs :value="active_step" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none"
                    id="profile-tabs" :key="isSmallerScreen">
                    <vs-tab icon-pack="feather" icon="icon-grid" :label="!isSmallerScreen ? 'Details' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <ActionView />
                        </div>
                    </vs-tab>
                    <vs-tab icon-pack="feather" icon="icon-file" :label="!isSmallerScreen ? 'Attachments' : ''">
                        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                            <ActionAttachments />
                        </div>
                    </vs-tab>
                </vs-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import ActionView from "./ActionView.vue"
import ActionAttachments from "./ActionAttachments.vue"
export default {
    name: "ActionHome",
    data() {
        return {
            active_step: this.$route.query.step ? this.$route.query.step : '0',
            action_id: null,
        }
    },
    components: {
        ActionView,
        ActionAttachments
    },
    computed: {
        isSmallerScreen() {
            return this.$store.state.windowWidth < 768
        }
    },

}
</script>
<style lang="">

</style>